/* eslint-disable */
import acpBasis from "@/services/acp.basis.service";
import mathFormulaService from "@/services/math.formula.service";
import actuatorService from "@/services/actuator.gasPneumatic.service";
import { buildAntriebDrehsObj } from "@/services/actuator.drehmoment-map.service";

type GetTableValuesDeps = {
    winkelKraftObject: any;
};

export const buildActuatorLabel = (driveType: string, antrieb: string, zylKey: number, federKEY: string) => {
    if (driveType === 'DA') {
        return antrieb + 'S-' + zylKey + '-' + driveType;
    }
    return antrieb + 'S-' + zylKey + '-' + driveType + '-' + federKEY;
};

export const findValidActuatorAtMinPressure = (
    deps: GetTableValuesDeps,
    dynKnickwinkel: number,
    antriebIndex: number,
    controlType: string,
    driveTypeA: string,
    driveType: string,
    items: number,
    minBar: number,
    maxNetActuatorTorque: number
) => {
    const { winkelKraftObject } = deps;

    let winkelArray: number[] = [];
    let khWinkelArray: number[] = [];
    let knicklaengeArray: number[] = [];
    let hebellaengeArray: number[] = [];
    let knickwinkelGradArray: number[] = [];
    let hebelwinkelGradArray: number[] = [];
    let zylinderKraftArray: number[] = [];
    let fResArray: number[] = [];
    let mZylArray: number[] = [];
    let fQuerArray: number[] = [];
    let hubTotalArray: number[] = [];
    let hub90ArrayHelper: number[] = [];

    let newAntrieb: any = {};
    let zylKey = 0;

    for (let zyl = 0; zyl < acpBasis.ZYLDURCHMESSER[antriebIndex].length; zyl++) {
        zylKey = acpBasis.ZYLDURCHMESSER[antriebIndex][zyl];

        winkelArray = [];
        khWinkelArray = [];
        knicklaengeArray = [];
        hebellaengeArray = [];
        knickwinkelGradArray = [];
        hebelwinkelGradArray = [];
        zylinderKraftArray = [];
        fResArray = [];
        mZylArray = [];
        fQuerArray = [];
        hubTotalArray = [];
        hub90ArrayHelper = [];

        let kolben_kreisringflaeche: any = {
            einfacherKolbenDurchmesser: 0,
            kolbeGesamflaeche: 0,
            kreisflaeche: 0,
            kreisring: 0,
            kreisringflaecheEinzeln: 0,
            kreisringflaecheGesamt: 0,
            kolbeFlaecheEinzeln: 0,
            kolbenstangeFlaecheEinzeln: 0
        };

        kolben_kreisringflaeche = actuatorService.flaecheZylinderrohrraum(controlType, acpBasis.ZYLDURCHMESSER[antriebIndex][zyl], items, antriebIndex, acpBasis.KOLBENSTANGE_DURCHMESSER_ARRAY);
        const zylinderkraft = actuatorService.getZylinderkraft(driveType, minBar, kolben_kreisringflaeche.kolbeGesamflaeche);
        const tableValues = actuatorService.getTable(antriebIndex, dynKnickwinkel, zylinderkraft, driveTypeA);

        winkelArray = tableValues.winkelArray;
        khWinkelArray = tableValues.khWinkelArray;
        knicklaengeArray = tableValues.knicklaengeArray;
        hebellaengeArray = tableValues.hebellaengeArray;
        knickwinkelGradArray = tableValues.knickwinkelGradArray;
        hebelwinkelGradArray = tableValues.hebelwinkelGradArray;
        zylinderKraftArray = tableValues.zylinderKraftArray;
        fResArray = tableValues.fResArray;
        mZylArray = tableValues.mZylArray;
        fQuerArray = tableValues.fQuerArray;
        hubTotalArray = tableValues.hubTotalArray;
        hub90ArrayHelper = tableValues.hub90ArrayHelper;

        newAntrieb[zylKey] = {
            khWinkelArray,
            winkelArray,
            knicklaengeArray,
            hebellaengeArray,
            knickwinkelGradArray,
            hebelwinkelGradArray,
            zylinderKraftArray,
            fResArray,
            mZylArray,
            fQuerArray,
            hubTotalArray,
            hub90ArrayHelper
        };

        let src: any = {};
        let sro: any = {};

        let federkraftArray: number[] = [];
        let fRESFederzylinderArray: number[] = [];
        let mFEDFederzylinderArray: number[] = [];
        let fQuerFederzylinderArray: number[] = [];
        let mResZylArray: number[] = [];
        let klappeBTOETOArray: number[] = [];
        let klappeBTCETCArray: number[] = [];

        let federkraftSROarray: number[] = [];
        let fRESFederzylinderSROarray: number[] = [];
        let mFEDFederzylinderSROarray: number[] = [];
        let fQuerFederzylinderSROarray: number[] = [];
        let mResZylSROarray: number[] = [];
        let klappeSRO_BTOETOarray: number[] = [];
        let klappeSRO_BTCETCarray: number[] = [];

        let federKEY = '';
        let isOverMaxAct = false;

        if (driveType === 'DA') {
            const klappeDA_BTOETOarray = actuatorService.getKlappe().open;
            const klappeDA_BTCETCarray = actuatorService.getKlappe().close;

            const zylKraftClose = actuatorService.getZylinderkraft(driveType, minBar, kolben_kreisringflaeche.kreisringflaecheGesamt);
            const tableValuesClose = actuatorService.getTable(antriebIndex, dynKnickwinkel, zylKraftClose, driveTypeA);
            const tableValuesOpen = tableValues;

            const chartDA = actuatorService.checkChartDA(tableValuesOpen.mZylArray, tableValuesClose.mZylArray, antriebIndex, zyl, 'forward', maxNetActuatorTorque);

            if (chartDA.ismZylOK && !chartDA.isOverMaxAct && chartDA.cantedEndmomentLaufmomentOK) {
                return {
                    mast: {},
                    antriebsIndex: antriebIndex,
                    zylIndex: zyl,
                    federIndex: 0,
                    antriebDrehsObj: buildAntriebDrehsObj({
                        openArray: tableValuesOpen.mZylArray,
                        closeArray: tableValuesClose.mZylArray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    }),
                    chart: {
                        klappeOPEN: klappeDA_BTOETOarray,
                        klappeCLOSE: klappeDA_BTCETCarray,
                        mZylArray: newAntrieb[zylKey].mZylArray,
                        maxNettoDrehmoment: maxNetActuatorTorque,
                        driveType,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        drehWinkel: winkelKraftObject
                    },
                    label: buildActuatorLabel(driveType, acpBasis.ANTRIEBE_ARRAY[antriebIndex], zylKey, federKEY),
                    zylinderVolumenP: mathFormulaService.zylinderVolumenP(
                        kolben_kreisringflaeche.kolbeFlaecheEinzeln,
                        kolben_kreisringflaeche.kreisringflaecheEinzeln,
                        items,
                        acpBasis.VERSTELLBEREICH_ARRAY[antriebIndex],
                        acpBasis.HUB_ARRAY[antriebIndex]
                    )
                };
            }
        } else {
            for (let paket = 0; paket < acpBasis.FEDERPAKETEARRAY[antriebIndex][zyl].length; paket++) {
                federKEY = acpBasis.FEDERPAKETEARRAY[antriebIndex][zyl][paket];

                federkraftArray = [];
                fRESFederzylinderArray = [];
                mFEDFederzylinderArray = [];
                fQuerFederzylinderArray = [];
                mResZylArray = [];
                klappeBTOETOArray = [];
                klappeBTCETCArray = [];

                federkraftSROarray = [];
                fRESFederzylinderSROarray = [];
                mFEDFederzylinderSROarray = [];
                fQuerFederzylinderSROarray = [];
                mResZylSROarray = [];
                klappeSRO_BTOETOarray = [];
                klappeSRO_BTCETCarray = [];

                const myFederTables = actuatorService.getFederTable(antriebIndex, paket, driveTypeA, hubTotalArray, hebelwinkelGradArray, hebellaengeArray, mZylArray, dynKnickwinkel, federKEY);

                const mySRC = myFederTables.src;
                federkraftArray = mySRC.federkraftArray;
                fRESFederzylinderArray = mySRC.fRESFederzylinderArray;
                mFEDFederzylinderArray = mySRC.mFEDFederzylinderArray;
                fQuerFederzylinderArray = mySRC.fQuerFederzylinderArray;
                mResZylArray = mySRC.mResZylArray;
                klappeBTOETOArray = mySRC.klappeBTOETOArray;
                klappeBTCETCArray = mySRC.klappeBTCETCArray;

                const mySRO = myFederTables.sro;
                federkraftSROarray = mySRO.federkraftSROarray;
                fRESFederzylinderSROarray = mySRO.fRESFederzylinderSROarray;
                mFEDFederzylinderSROarray = mySRO.mFEDFederzylinderSROarray;
                fQuerFederzylinderSROarray = mySRO.fQuerFederzylinderSROarray;
                mResZylSROarray = mySRO.mResZylSROarray;
                klappeSRO_BTOETOarray = mySRO.klappeSRO_BTOETOarray;
                klappeSRO_BTCETCarray = mySRO.klappeSRO_BTCETCarray;

                let federOK = false;
                let cantedEndmomentLaufmomentOK = false;
                let antriebDrehsObj: any;

                if (driveType === 'SO') {
                    const chartSRO = actuatorService.checkChartSRO(mFEDFederzylinderSROarray, mResZylSROarray, maxNetActuatorTorque);
                    federOK = chartSRO.federOK;
                    isOverMaxAct = chartSRO.isOverMaxAct;
                    cantedEndmomentLaufmomentOK = chartSRO.cantedEndmomentLaufmomentOK;

                    antriebDrehsObj = buildAntriebDrehsObj({
                        openArray: mFEDFederzylinderSROarray,
                        closeArray: mResZylSROarray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    });

                    sro = {
                        federkraft: federkraftSROarray,
                        fRES: fRESFederzylinderSROarray,
                        mFED: mFEDFederzylinderSROarray,
                        fQUER: fQuerFederzylinderSROarray,
                        mResZYL: mResZylSROarray,
                        klappeBTO_ETO: klappeSRO_BTOETOarray,
                        klappeBTC_ETC: klappeSRO_BTCETCarray,
                        federOK
                    };
                } else if (driveType === 'SC') {
                    const chartSRC = actuatorService.checkChartSRC(mFEDFederzylinderArray, mResZylArray, maxNetActuatorTorque);
                    federOK = chartSRC.federOK;
                    isOverMaxAct = chartSRC.isOverMaxAct;
                    cantedEndmomentLaufmomentOK = chartSRC.cantedEndmomentLaufmomentOK;

                    antriebDrehsObj = buildAntriebDrehsObj({
                        openArray: mResZylArray,
                        closeArray: mFEDFederzylinderArray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    });

                    src = {
                        federkraft: federkraftArray,
                        fRES: fRESFederzylinderArray,
                        mFED: mFEDFederzylinderArray,
                        fQUER: fQuerFederzylinderArray,
                        mResZYL: mResZylArray,
                        klappeBTO_ETO: klappeBTOETOArray,
                        klappeBTC_ETC: klappeBTCETCArray,
                        federOK
                    };
                }

                if (federOK && !isOverMaxAct && cantedEndmomentLaufmomentOK) {
                    newAntrieb[zylKey][federKEY] = {
                        src,
                        sro,
                        maxDrehUberschritten: isOverMaxAct
                    };

                    return {
                        mast: {},
                        antriebsIndex: antriebIndex,
                        zylIndex: zyl,
                        federIndex: paket,
                        antriebDrehsObj,
                        label: buildActuatorLabel(driveType, acpBasis.ANTRIEBE_ARRAY[antriebIndex], zylKey, federKEY),
                        zylinderVolumenP: mathFormulaService.zylinderVolumenP(
                            kolben_kreisringflaeche.kolbeFlaecheEinzeln,
                            kolben_kreisringflaeche.kreisringflaecheEinzeln,
                            items,
                            acpBasis.VERSTELLBEREICH_ARRAY[antriebIndex],
                            acpBasis.HUB_ARRAY[antriebIndex]
                        ),
                        chart: {
                            klappeBTO_ETO: (driveType === 'SO') ? klappeSRO_BTOETOarray : klappeBTOETOArray,
                            klappeBTC_ETC: (driveType === 'SO') ? klappeSRO_BTCETCarray : klappeBTCETCArray,
                            mResZYL: (driveType === 'SO') ? mResZylSROarray : mResZylArray,
                            mFED: (driveType === 'SO') ? mFEDFederzylinderSROarray : mFEDFederzylinderArray,
                            maxNettoDrehmoment: maxNetActuatorTorque,
                            driveType,
                            isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                            drehWinkel: winkelKraftObject
                        }
                    };
                }
            }
        }
    }

    return undefined;
};

export const checkValidActuatorAtMaxPressure = (
    deps: GetTableValuesDeps,
    dynKnickwinkel: number,
    antriebsIndex: number,
    controlType: string,
    driveTypeA: string,
    driveType: string,
    zylIndex: number,
    federIndex: number,
    items: number,
    maxBar: number,
    maxNetActuatorTorque: number
) => {
    const { winkelKraftObject } = deps;

    const zylKey = acpBasis.ZYLDURCHMESSER[antriebsIndex][zylIndex];

    const kolben_kreisringflaeche = actuatorService.flaecheZylinderrohrraum(
        controlType,
        acpBasis.ZYLDURCHMESSER[antriebsIndex][zylIndex],
        items,
        antriebsIndex,
        acpBasis.KOLBENSTANGE_DURCHMESSER_ARRAY
    );
    const zylinderkraft = actuatorService.getZylinderkraft(driveType, maxBar, kolben_kreisringflaeche.kolbeGesamflaeche);

    const tableValues = actuatorService.getTable(antriebsIndex, dynKnickwinkel, zylinderkraft, driveTypeA);

    let src: any = {};
    let sro: any = {};

    let federkraftArray: number[] = [];
    let fRESFederzylinderArray: number[] = [];
    let mFEDFederzylinderArray: number[] = [];
    let fQuerFederzylinderArray: number[] = [];
    let mResZylArray: number[] = [];
    let klappeBTOETOArray: number[] = [];
    let klappeBTCETCArray: number[] = [];

    let federkraftSROarray: number[] = [];
    let fRESFederzylinderSROarray: number[] = [];
    let mFEDFederzylinderSROarray: number[] = [];
    let fQuerFederzylinderSROarray: number[] = [];
    let mResZylSROarray: number[] = [];
    let klappeSRO_BTOETOarray: number[] = [];
    let klappeSRO_BTCETCarray: number[] = [];

    let federKEY = '';
    let isOverMaxAct = false;

    if (driveType === 'DA') {
        const klappeDA_BTOETOarray = actuatorService.getKlappe().open;
        const klappeDA_BTCETCarray = actuatorService.getKlappe().close;

        const zylKraftClose = actuatorService.getZylinderkraft(driveType, maxBar, kolben_kreisringflaeche.kreisringflaecheGesamt);
        const tableValuesClose = actuatorService.getTable(antriebsIndex, dynKnickwinkel, zylKraftClose, driveTypeA);
        const tableValuesOpen = tableValues;

        const chartDA = actuatorService.checkChartDA(tableValuesOpen.mZylArray, tableValuesClose.mZylArray, antriebsIndex, zylKey, 'forward', maxNetActuatorTorque);

        if (chartDA.ismZylOK && !chartDA.isOverMaxAct && chartDA.cantedEndmomentLaufmomentOK) {
            return {
                antriebDrehsObj: buildAntriebDrehsObj({
                    openArray: tableValuesOpen.mZylArray,
                    closeArray: tableValuesClose.mZylArray,
                    isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                    winkelKraftObject,
                    mode: 'forward'
                }),
                chart: {
                    klappeOPEN: klappeDA_BTOETOarray,
                    klappeCLOSE: klappeDA_BTCETCarray,
                    mZylArray: tableValues.mZylArray,
                    driveType,
                    isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                    drehWinkel: winkelKraftObject
                },
                label: buildActuatorLabel(driveType, acpBasis.ANTRIEBE_ARRAY[antriebsIndex], zylKey, federKEY),
                zylinderVolumenP: mathFormulaService.zylinderVolumenP(
                    kolben_kreisringflaeche.kolbeFlaecheEinzeln,
                    kolben_kreisringflaeche.kreisringflaecheEinzeln,
                    items,
                    acpBasis.VERSTELLBEREICH_ARRAY[antriebsIndex],
                    acpBasis.HUB_ARRAY[antriebsIndex]
                )
            };
        }
    } else {
        federKEY = acpBasis.FEDERPAKETEARRAY[antriebsIndex][zylIndex][federIndex];

        const myFederTables = actuatorService.getFederTable(
            antriebsIndex,
            federIndex,
            driveTypeA,
            tableValues.hubTotalArray,
            tableValues.hebelwinkelGradArray,
            tableValues.hebellaengeArray,
            tableValues.mZylArray,
            dynKnickwinkel,
            federKEY
        );

        const mySRC = myFederTables.src;
        federkraftArray = mySRC.federkraftArray;
        fRESFederzylinderArray = mySRC.fRESFederzylinderArray;
        mFEDFederzylinderArray = mySRC.mFEDFederzylinderArray;
        fQuerFederzylinderArray = mySRC.fQuerFederzylinderArray;
        mResZylArray = mySRC.mResZylArray;
        klappeBTOETOArray = mySRC.klappeBTOETOArray;
        klappeBTCETCArray = mySRC.klappeBTCETCArray;

        const mySRO = myFederTables.sro;
        federkraftSROarray = mySRO.federkraftSROarray;
        fRESFederzylinderSROarray = mySRO.fRESFederzylinderSROarray;
        mFEDFederzylinderSROarray = mySRO.mFEDFederzylinderSROarray;
        fQuerFederzylinderSROarray = mySRO.fQuerFederzylinderSROarray;
        mResZylSROarray = mySRO.mResZylSROarray;
        klappeSRO_BTOETOarray = mySRO.klappeSRO_BTOETOarray;
        klappeSRO_BTCETCarray = mySRO.klappeSRO_BTCETCarray;

        let federOK: boolean;
        let cantedEndmomentLaufmomentOK: boolean;
        let antriebDrehsObj: any;

        if (driveType === 'SO') {
            const chartSRO = actuatorService.checkChartSRO(mFEDFederzylinderSROarray, mResZylSROarray, maxNetActuatorTorque);
            federOK = chartSRO.federOK;
            isOverMaxAct = chartSRO.isOverMaxAct;
            cantedEndmomentLaufmomentOK = chartSRO.cantedEndmomentLaufmomentOK;

            antriebDrehsObj = buildAntriebDrehsObj({
                openArray: mFEDFederzylinderSROarray,
                closeArray: mResZylSROarray,
                isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                winkelKraftObject,
                mode: 'forward'
            });

            sro = {
                federkraft: federkraftSROarray,
                fRES: fRESFederzylinderSROarray,
                mFED: mFEDFederzylinderSROarray,
                fQUER: fQuerFederzylinderSROarray,
                mResZYL: mResZylSROarray,
                klappeBTO_ETO: klappeSRO_BTOETOarray,
                klappeBTC_ETC: klappeSRO_BTCETCarray,
                federOK: chartSRO.federOK
            };
        } else {
            const chartSRC = actuatorService.checkChartSRC(mFEDFederzylinderArray, mResZylArray, maxNetActuatorTorque);
            federOK = chartSRC.federOK;
            isOverMaxAct = chartSRC.isOverMaxAct;
            cantedEndmomentLaufmomentOK = chartSRC.cantedEndmomentLaufmomentOK;

            antriebDrehsObj = buildAntriebDrehsObj({
                openArray: mResZylArray,
                closeArray: mFEDFederzylinderArray,
                isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                winkelKraftObject,
                mode: 'forward'
            });

            src = {
                federkraft: federkraftArray,
                fRES: fRESFederzylinderArray,
                mFED: mFEDFederzylinderArray,
                fQUER: fQuerFederzylinderArray,
                mResZYL: mResZylArray,
                klappeBTO_ETO: klappeBTOETOArray,
                klappeBTC_ETC: klappeBTCETCArray,
                federOK
            };
        }

        if (federOK && !isOverMaxAct && cantedEndmomentLaufmomentOK) {
            return {
                antriebDrehsObj,
                label: buildActuatorLabel(driveType, acpBasis.ANTRIEBE_ARRAY[antriebsIndex], zylKey, federKEY),
                zylinderVolumenP: mathFormulaService.zylinderVolumenP(
                    kolben_kreisringflaeche.kolbeFlaecheEinzeln,
                    kolben_kreisringflaeche.kreisringflaecheEinzeln,
                    items,
                    acpBasis.VERSTELLBEREICH_ARRAY[antriebsIndex],
                    acpBasis.HUB_ARRAY[antriebsIndex]
                ),
                chart: {
                    klappeBTO_ETO: (driveType === 'SO') ? klappeSRO_BTOETOarray : klappeBTOETOArray,
                    klappeBTC_ETC: (driveType === 'SO') ? klappeSRO_BTCETCarray : klappeBTCETCArray,
                    mResZYL: (driveType === 'SO') ? mResZylSROarray : mResZylArray,
                    mFED: (driveType === 'SO') ? mFEDFederzylinderSROarray : mFEDFederzylinderArray,
                    maxNettoDrehmoment: maxNetActuatorTorque,
                    driveType,
                    isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                    drehWinkel: winkelKraftObject
                }
            };
        }
    }

    return undefined;
};
